import React from 'react';

import { Box, Divider, Paper } from '@mui/material';

type DetailPanelProps = {
  height?: string;
  children: React.ReactNode;
  /** スクロール領域の外（下部固定）に表示するフッター */
  footer?: React.ReactNode;
  /** 左端にフロート表示する折りたたみトグル（リスト非表示時） */
  collapseToggle?: React.ReactNode;
  /**
   * 未選択などで表示する内容が無いときに children の代わりに表示する空状態（任意）。
   * isEmpty=true のときのみ有効。指定しなければ従来どおり children を表示する。
   */
  emptyState?: React.ReactNode;
  /** emptyState を表示するか（true かつ emptyState 指定時に children の代わりに表示） */
  isEmpty?: boolean;
};

const DetailPanel: React.FC<DetailPanelProps> = ({
  height = 'calc(100vh - 140px)',
  children,
  footer,
  collapseToggle,
  emptyState,
  isEmpty = false,
}) => {
  const showEmpty = isEmpty && emptyState;
  return (
    <Paper
      elevation={0}
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height,
        position: 'relative',
      }}
    >
      {collapseToggle}
      {showEmpty ? (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
          }}
        >
          {emptyState}
        </Box>
      ) : (
        <Box sx={{ overflow: 'auto', flexGrow: 1, p: 3 }}>{children}</Box>
      )}
      {footer && !showEmpty && (
        <>
          <Divider />
          <Box sx={{ p: 2, flexShrink: 0 }}>{footer}</Box>
        </>
      )}
    </Paper>
  );
};

export default DetailPanel;
